
<div
	class="flow-switch-container"
	:on="innerOn"
	:disabled="disabled"
	:tabindex="tabindex"
	:type="type"
	:size="size"
	@click="handleClick"
>
	<div class="flow-switch-ball" />
</div>
